import { FormattedMessage } from 'react-intl';

import { Modal, ResponsiveWidth } from '../../../../../../common';
import { BonusPointsModalProps } from './bonus-points-modal.models';

export const BonusPointsModal = ({ points, packageNumber, ...props }: BonusPointsModalProps): JSX.Element => (
  <Modal
    {...props}
    title={<FormattedMessage id="order.delivery.total.points.modalTitle" />}
    responsiveWidth={ResponsiveWidth.xs}
    content={(
      <p data-testid="bonus-points-modal-content">
        <FormattedMessage
          id="order.delivery.total.pointsTooltip"
          values={{ points, packageNumber }}
        />
      </p>
    )}
  />
);
